function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import dropdownMenuLayout from './dropdownMenuLayout';

function wixDropdownMenuWrapper(WixElement, services) {
  var WixDropdownMenu =
  /*#__PURE__*/
  function (_WixElement) {
    _inheritsLoose(WixDropdownMenu, _WixElement);

    function WixDropdownMenu() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _WixElement.call.apply(_WixElement, [this].concat(args)) || this;

      _defineProperty(_assertThisInitialized(_this), "_visible", false);

      _defineProperty(_assertThisInitialized(_this), "_mutationIds", {
        read: null,
        write: null
      });

      _defineProperty(_assertThisInitialized(_this), "_itemsContainer", null);

      _defineProperty(_assertThisInitialized(_this), "_dropContainer", null);

      _defineProperty(_assertThisInitialized(_this), "_labelItems", []);

      return _this;
    }

    var _proto = WixDropdownMenu.prototype;

    _proto.attributeChangedCallback = function attributeChangedCallback() {
      if (this._isVisible()) {
        this.reLayout();
      }
    };

    _proto.connectedCallback = function connectedCallback() {
      var _this2 = this;

      this._id = this.getAttribute('id');

      this._hideElement();

      this._waitForDomLoad().then(function () {
        _WixElement.prototype.observeResize.call(_this2);

        _this2._observeChildrenResize();

        _this2.reLayout();
      });
    };

    _proto.disconnectedCallback = function disconnectedCallback() {
      services.mutationService.clear(this._mutationIds.read);
      services.mutationService.clear(this._mutationIds.write);

      _WixElement.prototype.disconnectedCallback.call(this);
    };

    _proto._waitForDomLoad = function _waitForDomLoad() {
      var _this3 = this;

      var onReady;
      var loadPromise = new Promise(function (res) {
        onReady = res;
      });

      if (this._isDomReady()) {
        onReady();
      } else {
        this._waitForDomReadyObserver = new MutationObserver(function () {
          return _this3._onRootMutate(onReady);
        });

        this._waitForDomReadyObserver.observe(this, {
          childList: true,
          subtree: true
        });
      }

      return loadPromise;
    };

    _proto._isDomReady = function _isDomReady() {
      this._itemsContainer = document.getElementById(this._id + "itemsContainer");
      this._dropContainer = document.getElementById(this._id + "dropWrapper");
      return this._itemsContainer && this._dropContainer;
    };

    _proto._onRootMutate = function _onRootMutate(onReady) {
      if (this._isDomReady()) {
        this._waitForDomReadyObserver.disconnect();

        onReady();
      }
    };

    _proto._observeChildrenResize = function _observeChildrenResize() {
      var _this4 = this;

      var menuItems = Array.from(this._itemsContainer.childNodes);
      this._labelItems = menuItems.map(function (item) {
        return document.getElementById(item.getAttribute('id') + "label");
      });

      this._labelItems.forEach(function (item) {
        return _WixElement.prototype.observeChildResize.call(_this4, item);
      });
    };

    _proto._setVisibility = function _setVisibility(visible) {
      this._visible = visible;
      this.style.visibility = visible ? '' : 'hidden';
    };

    _proto._isVisible = function _isVisible() {
      return this._visible;
    };

    _proto._hideElement = function _hideElement() {
      this._setVisibility(false);
    };

    _proto._showElement = function _showElement() {
      this._setVisibility(true);
    };

    _proto.reLayout = function reLayout() {
      var _this5 = this;

      var measures, domNodes;
      services.mutationService.clear(this._mutationIds.read);
      services.mutationService.clear(this._mutationIds.write);
      this._mutationIds.read = services.mutationService.measure(function () {
        var measureResult = dropdownMenuLayout.measure(_this5._id);
        measures = measureResult.measures;
        domNodes = measureResult.domNodes;
      });
      this._mutationIds.write = services.mutationService.mutate(function () {
        dropdownMenuLayout.patch(_this5._id, measures, domNodes);

        _this5._showElement();
      });
    };

    _createClass(WixDropdownMenu, null, [{
      key: "observedAttributes",
      get: function get() {
        return ['data-hovered-item'];
      }
    }]);

    return WixDropdownMenu;
  }(WixElement);

  return WixDropdownMenu;
}

export default wixDropdownMenuWrapper;
//# sourceMappingURL=wixDropdownMenu.js.map